export function filterElementToImageIgnore(node) {
  const exclusionClasses = ['data-html-to-image-ignore'];
  return !exclusionClasses.some((classname) =>
    node.classList?.contains(classname)
  );
}
